import React, { useState } from "react";
import PlatformWidget from "../platformWidget/PlatformWidget";

import FacebookIcon from "../../../../../assets/svg/facebook-icon.svg";
import TwitterIcon from "../../../../../assets/svg/twitter-logo.svg";
import InstagramIcon from "../../../../../assets/svg/instagram.svg";
import YoutubeIcon from "../../../../../assets/svg/youtube-icon.svg";
import RedditIcon from "../../../../../assets/svg/reddit-icon.svg";
import TwitchIcon from "../../../../../assets/svg/twitch-icon.svg";
import PinterestIcon from "../../../../../assets/svg/pinterest-icon.svg";
import TiktokIcon from "../../../../../assets/svg/tiktok-icon.svg";
import BlogIcon from "../../../../../assets/svg/blog-icon.svg";
import NewsIcon from "../../../../../assets/svg/news-icon.svg";
import DiscordIcon from "../../../../../assets/svg/discord-icon.svg";
import ForumsIcon from "../../../../../assets/svg/forum-icon.svg";
import TelegramIcon from "../../../../../assets/svg/telegram-icon.svg";

import "./SelectPlatform.scss";
import FacebookConfig from "../platforms/FacebookConfig";
import PlatformWrapper from "../platformWrapper/PlatformWrapper";
import InstagramConfig from "../platforms/InstagramConfig";
import OtherPlatformsConfig from "../platforms/OtherPlatformsConfig";
import TiktokConfig from "../platforms/TiktokConfig";

const platformList = {
    "Social Network": [
        { name: "Facebook", icon: FacebookIcon, path: "facebook", component: FacebookConfig },
        { name: "Instagram", icon: InstagramIcon, path: "instagram", component: InstagramConfig },
        { name: "Pinterest", icon: PinterestIcon, path: "pinterest", component: OtherPlatformsConfig },
        { name: "Reddit", icon: RedditIcon, path: "reddit", component: OtherPlatformsConfig },
        { name: "X", icon: TwitterIcon, path: "twitter", component: OtherPlatformsConfig },
        { name: "YouTube", icon: YoutubeIcon, path: "youtube", component: OtherPlatformsConfig },
        // { name: "Twitch", icon: TwitchIcon, path: "twitch", component: OtherPlatformsConfig },
        // { name: "Telegram", icon: TelegramIcon, path: "telegram", component: OtherPlatformsConfig },
        // { name: "Discord", icon: DiscordIcon, path: "discord", component: OtherPlatformsConfig },
        { name: "TikTok", icon: TiktokIcon, path: "tiktok", component: TiktokConfig },
    ],
    "Forums and News": [
        { name: "Forums", icon: ForumsIcon, path: "forum", component: OtherPlatformsConfig },
        { name: "News", icon: NewsIcon, path: "news", component: OtherPlatformsConfig },
    ],
    Blog: [{ name: "Blog", icon: BlogIcon, path: "blog", component: OtherPlatformsConfig }],
};

function SelectPlatform({ platform, setPlatform, ...props }) {
    let selectedComponent;
    let selectedPlarforms = props.accountListData?.map((ac) => ac.platform_name);
    // let posts = props.postListData.length;
    const counts = {};

    selectedPlarforms.map((val) => {
        counts[val] = counts[val] ? counts[val] + 1 : 1;
    });

    if (counts["fbcomment"] && counts["facebook"]) {
        counts["facebook"] = counts["facebook"] + counts["fbcomment"];
    }

    if (counts["fbcomment"] && !counts["facebook"]) {
        counts["facebook"] = counts["fbcomment"];
    }

    if (counts["facebook_post"] && counts["facebook"]) {
        counts["facebook"] = counts["facebook"] + counts["facebook_post"];
    }

    if (counts["facebook_post"] && !counts["facebook"]) {
        counts["facebook"] = counts["facebook_post"];
    }

    if (props.tiktokKeyword && counts["tiktok"]) {
        counts["tiktok"] = counts["tiktok"] + 1;
    }

    if (props.tiktokKeyword && !counts["tiktok"]) {
        counts["tiktok"] = 1;
    }

    if (platform) {
        let flattenedArray = [];
        const allArrays = Object.values(platformList);
        flattenedArray = allArrays.flat();
        selectedComponent = flattenedArray.find((obj) => obj.path === platform);
    }

    if (!platform) {
        return (
            <div className="selectPlatformContainer">
                <p className="selectPlatformHeader">
                    Select a platform and then configure accounts and pages you would like to fetch data from. We will automatically get historic data for you
                    where available. Some of the platforms require you to authenticate before we can get data.
                </p>
                <p>Note: Maximum 20 accounts are allowed at a time</p>
                <div className="selectPlatform">
                    {Object.keys(platformList).map((category) => (
                        <div key={category} className="platformCategory">
                            <p className="platformCategoryName">{category}</p>
                            <div className="platformList">
                                {platformList[category].map(({ name, icon, path }) => (
                                    <PlatformWidget
                                        key={path}
                                        name={name}
                                        icon={icon}
                                        path={path}
                                        setPlatform={setPlatform}
                                        changeIsPlatformOpened={props.changeIsPlatformOpened}
                                        counts={counts}
                                        isDisabled={props.isTiktokDisabled}
                                        // isDisabled={false}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    } else {
        return (
            <PlatformWrapper
                component={selectedComponent.component}
                platformName={selectedComponent.path}
                icon={selectedComponent.icon}
                setCheckIsDirty={props.setCheckIsDirty}
                closeComponent={() => {
                    setPlatform(null);
                    props.changeIsPlatformOpened(false);
                }}
            />
        );
    }
}

export default SelectPlatform;
